import { useCallback } from "react";
import { useEnvContext } from "../contexts/env-context";

export const useIsAuthenticated = () => {
	const { account } = useEnvContext();

	return useCallback(() => eXpress.AccountId.isNotEmpty(account.id), [account]);
};
